import classNames from 'classnames';
import { SidebarItemProps } from './types';

export const SidebarItem = ({ 
  icon, 
  label, 
  isClickable = true, 
  isActive = false, 
  onClick, 
  isCollapsed = false, 
  customActiveStyle = false, 
  badge,
  isDisabled = false,
}: SidebarItemProps) => (
  <div
    className={classNames(`flex rounded-lg items-center font-roboto transition-[background-color] duration-200 text-white ${
      isActive
        ? customActiveStyle
          ? 'bg-white relative overflow-hidden'
          : 'bg-menu-hover/50'
        : ''
      }`, {
      'opacity-40 cursor-not-allowed': isDisabled,
      'cursor-pointer hover:bg-menu-hover/40 ': !isDisabled,
      'px-2 py-2': !isCollapsed,
      'p-2 justify-center aspect-square w-fit mx-auto': isCollapsed,
    })}
    onClick={isClickable && !isDisabled ? onClick : undefined}
    title={isCollapsed ? label : undefined}
  >
    {isActive && customActiveStyle && (
      <>
        <div className="absolute inset-0 bg-(--blue-grey) z-0"></div>
        <div className="absolute top-0 bottom-0 right-0 w-[5px] bg-(--live-green) z-0"></div>
      </>
    )}
    <div className={classNames('flex items-center justify-center relative z-10 shrink-0')}>
      {icon}
    </div>
    {!isCollapsed && (
      <span className={classNames("text-base font-normal relative z-10 ml-3 flex items-center gap-2 min-w-0 flex-1") }>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap">{label}</span>
        {badge && (
          <span className="px-2 py-0.5 text-xs font-semibold rounded-full text-white shrink-0" style={{ backgroundColor: '#228995' }}>
            {badge}
          </span>
        )}
      </span>
    )}
  </div>
);
